import { WholesaleLanguage } from '../language/language';

export function getNotFoundUrl(lang: WholesaleLanguage, dealerSlug?: string): string {
    return `${dealerSlug ? `/${dealerSlug}` : ''}/${lang}/404`;
}
